/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-06-14 15:41:15
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-23 14:08:22
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/main.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./lang";
import http from "@/utils/http";
import "@/style/index.css";
import "@/style/icon.css";
import "@/style/fontSize.css";
import "@/style/font/cn.css";
import "@/style/font/en.css";
Vue.config.productionTip = false;

Vue.prototype.$http = http;
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 假数据引入
import getData from "@/utils/getData.js"; //引入
Vue.use(getData);
import {
  Form,
  Field,
  Checkbox,
  Button,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Popup,
  Cascader,
  Grid,
  GridItem,
  Tab,
  Tabs,
  List,
  Dialog,
  Toast,
  Picker,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  DatetimePicker,
  Divider,
  Uploader,
  Image as VanImage,
  ImagePreview,
  Row,
  Col,
  Search,
  Overlay,
  Popover,
  Loading,
  DropdownMenu,
  DropdownItem,
  Swipe,
  SwipeItem,
  IndexBar,
  IndexAnchor,
  PullRefresh,
  Badge,
  Pagination,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Checkbox)
  .use(Button)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(Cascader)
  .use(Grid)
  .use(GridItem)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Dialog)
  .use(Toast)
  .use(Picker)
  .use(Icon)
  .use(Cell)
  .use(CellGroup)
  .use(NavBar)
  .use(DatetimePicker)
  .use(Divider)
  .use(Row)
  .use(Col)
  .use(Uploader)
  .use(VanImage)
  .use(ImagePreview)
  .use(Search)
  .use(Overlay)
  .use(Popover)
  .use(Loading)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Badge)
  .use(PullRefresh)
  .use(Pagination);
import "vant/lib/index.css";

import ChartBlock from "@/components/ChartBlock";
Vue.use(ChartBlock);

import countTo from "vue-count-to";
Vue.component("countTo", countTo);

import wmtDate from "@/utils/date.js";
Vue.prototype.$wmtDate = wmtDate;

import VForm from "vform-builds"; //引入VForm库
import "vform-builds/dist/VFormDesigner.css"; //引入VForm样式
Vue.use(VForm);
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)

Vue.use(ElementUI);

// 引入全局注册组件
import globalComponent from "./utils/globalComponent.js";
Vue.use(globalComponent);

Vue.prototype.$videoSuffix = ["mp4", "mov", "avi"];

import Bus from "@/utils/eventBus.js";

import VueAwesomeSwiper from "vue-awesome-swiper";

//引入样式
import "swiper/swiper.css";

Vue.use(VueAwesomeSwiper);

Vue.prototype.$eventBus = Bus;

Vue.directive("blank", {
  inserted: function (el) {
    console.log(el);
    if (el.tagName.toLowerCase() === "a") {
      el.setAttribute("target", "_blank");
      el.setAttribute("rel", "noopener noreferrer");
    }
  },
});

import VueCropper from "vue-cropper";
Vue.use(VueCropper);


import H5Cropper from 'vue-cropper-h5'
Vue.use(H5Cropper)


new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
